function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { PromocodeMeasurementEnum } from 'swag-common/constants/promocode';
import { DEFAULT_RESELLER_COMMISSION_PERCENT } from 'swag-common/constants/reseller.constants';
import { GET_RATES_SUCCESS } from '../checkout/checkout.actions';
import { SET_INVOICE_DISCOUNT_VALUE, SET_LINE_ITEM_VALUE, SET_INITIAL_VALUES, SAVE_INVOICE_REQUEST, SAVE_INVOICE_SUCCESS, SAVE_INVOICE_ERROR, GET_RESELLER_COMMISSION_REQUEST, GET_RESELLER_COMMISSION_SUCCESS, GET_RESELLER_COMMISSION_ERROR, SET_PAYMENT_TERM_VALUE, GET_RESELLER_INVENTORY_CONTRACT_SUCCESS, SIGN_INVENTORY_CONTRACT_SUCCESS } from './reseller-invoice.actions';
import { getCommissionFromResellerPrice, getItemMultiplier, getResellerPriceFromCommission, recalculateResellerItemPrices, validateLineItems } from './reseller-invoice.utils';
export let ResellerInvoiceFormFields = /*#__PURE__*/function (ResellerInvoiceFormFields) {
  ResellerInvoiceFormFields["userItemPrice"] = "userItemPrice";
  ResellerInvoiceFormFields["commission"] = "commission";
  ResellerInvoiceFormFields["taxes"] = "taxes";
  ResellerInvoiceFormFields["discountType"] = "discountType";
  ResellerInvoiceFormFields["discountValue"] = "discountValue";
  ResellerInvoiceFormFields["freeTax"] = "freeTax";
  ResellerInvoiceFormFields["freeSetupFee"] = "freeSetupFee";
  ResellerInvoiceFormFields["freeShipping"] = "freeShipping";
  ResellerInvoiceFormFields["paymentTerm"] = "paymentTerm";
  return ResellerInvoiceFormFields;
}({});
const initialState = {
  loading: false,
  lineItems: [],
  previousLineItemsTaxes: {},
  resellerCommission: DEFAULT_RESELLER_COMMISSION_PERCENT,
  resellerTierCommission: 0,
  resellerBonusCommission: 0,
  resellerBonusCommissionThreshold: 0,
  discountData: {
    discountType: PromocodeMeasurementEnum.PERCENTAGES,
    discountValue: 0,
    freeTax: false,
    freeSetupFee: false,
    freeShipping: false
  },
  isInventoryContractSigned: false,
  paymentTerms: '',
  errors: {}
};
export const resellerInvoiceReducer = (state = initialState, {
  type,
  payload,
  body
}) => {
  switch (type) {
    case SET_INITIAL_VALUES:
      {
        const {
          lineItems,
          discountData
        } = payload;
        const errors = validateLineItems(lineItems);
        return _objectSpread({}, state, {
          lineItems,
          discountData,
          errors
        });
      }
    case SET_INVOICE_DISCOUNT_VALUE:
      {
        const {
          name,
          value
        } = payload;
        if (name === ResellerInvoiceFormFields.freeTax) {
          let updatedItems;
          let previousLineItemsTaxes;
          if (value) {
            previousLineItemsTaxes = state.lineItems.reduce((acc, {
              _id,
              taxes
            }) => {
              if (!acc[_id]) {
                acc[_id] = taxes;
              }
              return acc;
            }, {});
            updatedItems = state.lineItems.map(item => _objectSpread({}, item, {
              taxes: '0.00'
            }));
          } else {
            updatedItems = state.lineItems.map(item => _objectSpread({}, item, {
              taxes: state.previousLineItemsTaxes[item._id]
            }));
            previousLineItemsTaxes = {};
          }
          return _objectSpread({}, state, {
            lineItems: updatedItems,
            discountData: _objectSpread({}, state.discountData, {
              [name]: value
            }),
            previousLineItemsTaxes
          });
        }
        return _objectSpread({}, state, {
          discountData: _objectSpread({}, state.discountData, {
            [name]: value
          })
        });
      }
    case SET_PAYMENT_TERM_VALUE:
      {
        return _objectSpread({}, state, {
          paymentTerms: payload
        });
      }
    case GET_RATES_SUCCESS:
      {
        return _objectSpread({}, state, {
          paymentTerms: body.order.paymentTerms
        });
      }
    case SET_LINE_ITEM_VALUE:
      {
        const {
          id,
          value,
          name
        } = payload;
        const updatedItems = state.lineItems.map(item => {
          if (item._id !== id) {
            return item;
          }
          if (name === ResellerInvoiceFormFields.userItemPrice) {
            const updatedCommission = getCommissionFromResellerPrice({
              userPrice: parseFloat(value) || 0,
              basePrice: parseFloat(item.basePricePerItem),
              productMarginReduction: item.productMarginReduction,
              quantity: item.quantity,
              isSample: item.isSample,
              priceMultiplier: item.multiplier
            });
            const multiplier = getItemMultiplier(parseFloat(value), parseFloat(item.basePricePerItem), item.assemblyFee);
            return _objectSpread({}, item, {
              userItemPrice: value,
              commission: updatedCommission || 0,
              multiplier
            });
          }
          if (name === ResellerInvoiceFormFields.commission) {
            const updatedPrice = getResellerPriceFromCommission({
              commission: parseFloat(value) || 0,
              basePrice: parseFloat(item.basePricePerItem),
              productMarginReduction: item.productMarginReduction,
              quantity: item.quantity,
              isSample: item.isSample,
              priceMultiplier: item.multiplier
            });
            const multiplier = getItemMultiplier(Number(updatedPrice.toFixed(2)), parseFloat(item.basePricePerItem), item.assemblyFee);
            return _objectSpread({}, item, {
              userItemPrice: updatedPrice.toFixed(2),
              commission: parseFloat(value) || 0,
              multiplier
            });
          }
          if (name === ResellerInvoiceFormFields.taxes) {
            return _objectSpread({}, item, {
              taxes: value
            });
          }
          return item;
        });
        const errors = validateLineItems(updatedItems);
        const {
          resellerBonusCommission,
          resellerBonusCommissionThreshold,
          resellerTierCommission
        } = state;
        const recalculatedItems = recalculateResellerItemPrices({
          lineItems: updatedItems,
          resellerBonusCommission,
          resellerBonusCommissionThreshold,
          resellerTierCommission
        });
        return _objectSpread({}, state, {
          lineItems: recalculatedItems,
          errors: errors
        });
      }
    case GET_RESELLER_COMMISSION_SUCCESS:
      {
        const {
          resellerCommission,
          resellerTierCommission,
          resellerBonusCommission,
          resellerBonusCommissionThreshold
        } = payload;
        return _objectSpread({}, state, {
          resellerCommission,
          resellerTierCommission,
          resellerBonusCommission,
          resellerBonusCommissionThreshold,
          loading: false
        });
      }
    case GET_RESELLER_INVENTORY_CONTRACT_SUCCESS:
      {
        const {
          isContractSigned
        } = payload;
        return _objectSpread({}, state, {
          isInventoryContractSigned: isContractSigned
        });
      }
    case SIGN_INVENTORY_CONTRACT_SUCCESS:
      {
        return _objectSpread({}, state, {
          isInventoryContractSigned: true
        });
      }
    case SAVE_INVOICE_SUCCESS:
      {
        return _objectSpread({}, state, {
          loading: false
        });
      }
    case GET_RESELLER_COMMISSION_REQUEST:
    case SAVE_INVOICE_REQUEST:
      {
        return _objectSpread({}, state, {
          loading: true
        });
      }
    case GET_RESELLER_COMMISSION_ERROR:
    case SAVE_INVOICE_ERROR:
      {
        return _objectSpread({}, state, {
          loading: false
        });
      }
    default:
      {
        return state;
      }
  }
};